import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  DoCheck,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ConfigService } from '../../shared-services/config.service';
import { GlobalFilterService } from '../../shared-services/global-filter-service';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { map, startWith, Subject, takeUntil } from 'rxjs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPseudoCheckboxModule } from '@angular/material/core';
import {
  NgOptgroupTemplateDirective,
  NgOptionTemplateDirective,
  NgSelectComponent,
  NgSelectModule,
} from '@ng-select/ng-select';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-global-dropdown',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatPseudoCheckboxModule,
    NgSelectComponent,
    FormsModule,
    NgOptionTemplateDirective,
    NgSelectModule,
    MatIcon
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GlobalDropdownComponent),
      multi: true,
    },
  ],
  templateUrl: './global-dropdown.component.html',
  styleUrl: './global-dropdown.component.scss',
})
export class GlobalDropdownComponent
  implements ControlValueAccessor, OnChanges, DoCheck {
  @Input() data: any;
  @Input() options: any[] = [];
  @Output() filterChanged = new EventEmitter<any>();
  private suppressSelectionChange = false;
  private destroy$ = new Subject<void>();
  private lastOptionListHash: string = '';

  selected: any = [];
  searchCtrl = new FormControl('');
  filteredOptions: any[] = [];

  selectedDropdownList: { [key: string]: any[] } = {};

  private onChangeFn: (value: any) => void = () => { };
  private onTouchedFn: () => void = () => { };

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private globalFilterService: GlobalFilterService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {

    console.log('cdfghj inside global dropdown', this.data);
    this.searchCtrl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((searchText: string | null) => {
        console.log('searchText', searchText);
        const term = (searchText || '').toLowerCase();
        if (!term) {
          this.filteredOptions = [...this.options];
        } else {
          console.log('term2', term);
          this.filteredOptions = this.options.filter((opt) => {
            try {
              return this.getItemLabel(opt).toLowerCase().includes(term);
            } catch {
              return false;
            }
          });
        }
      });

    this.loadOptions();

    this.globalFilterService.resetState$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.resetSelection();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // If parent passed `options` input, normalize them
    if (changes['options'] && changes['options'].currentValue) {
      this.setOptionsFromRaw(changes['options'].currentValue || []);
    } else if (!changes['data']) {
      // No changes, ensure filteredOptions reflects current options
      this.filteredOptions = this.options || [];
    }

    // Watch for optionsList updates from parent (for dependent filters)
    if (changes['data'] && changes['data'].currentValue?.optionsList) {
      this.setOptionsFromRaw(this.data?.optionsList || []);
    }

    if (changes['data'] && changes['data'].currentValue?.apiUrl) {
      this.loadOptions();
    }
  }

  ngDoCheck(): void {
    // Detect when parent updates data.optionsList for dependent filters
    if (this.data?.optionsList) {
      const hash = JSON.stringify(this.data.optionsList);
      if (hash !== this.lastOptionListHash) {
        console.log('[GlobalDropdown] ngDoCheck detected option change:', {
          key: this.data?.key,
          oldHash: this.lastOptionListHash.substring(0, 50),
          newHash: hash.substring(0, 50),
          newOptionsCount: this.data.optionsList.length,
        });
        this.lastOptionListHash = hash;
        this.setOptionsFromRaw(this.data.optionsList);
      }
    }
  }


  private loadOptions(): void {
    console.log("loadoptions", this.data?.apiUrl)
    const url = this.data?.apiUrl;
    const payload = this.data?.payload;
    if (!url) return;

    // assets/* must be GET
    this.http.post<any[]>(url, payload).subscribe({
      next: (rawOptions) => {

        this.setOptionsFromRaw(rawOptions || []);
      },
      error: (err) => {
        console.error('[GlobalDropdown] Failed to load options from', url, err);
        this.setOptionsFromRaw([]);
      },
    });
  }

  private setOptionsFromRaw(rawOptions: any[]) {

    // console.log('qwerty set options from raw' , rawOptions);
    const displayField = this.data?.displayField;
    const valueField = this.data?.valueField;
    // console.log('qwerty displayField and valueField' , {displayField, valueField});

    // console.log('qwerty [GlobalDropdown] setOptionsFromRaw called:', {
    //   key: this.data?.key,
    //   displayField,
    //   valueField,
    //   rawOptionsCount: rawOptions?.length,
    //   rawOptions: rawOptions?.slice(0, 3),
    // });

    const normalized = (rawOptions || []).map((item: any) => {
      if (typeof item === 'string') return item;
      if (displayField && item && item[displayField] !== undefined) return item[displayField];
      if (valueField && item && item[valueField] !== undefined) return item[valueField];
      if (item && item['bundle_id'] !== undefined) return item['bundle_id'];
      if (item && item['name'] !== undefined) return item['name'];
      if (item && item['value'] !== undefined) return item['value'];
      try {
        return JSON.stringify(item);
      } catch {
        return String(item);
      }
    });

    console.log('[GlobalDropdown] normalized options:', {
      key: this.data?.key,
      normalizedCount: normalized.length,
      normalized: normalized.slice(0, 5),
    });

    this.options = normalized;
    this.filteredOptions = [...this.options];
    this.cdr.markForCheck();
  }

  get isAllSelected(): boolean {
    return (
      this.options?.length > 0 &&
      this.selected?.length === this.options.length
    );
  }

  isItemSelected(item: any): boolean {
    return this.selected?.includes(item);
  }

  toggleSelectAll(event: any): void {
    const isChecked = event?.target?.checked;

    // Prevent triggering onChange again
    this.suppressSelectionChange = true;
    this.selected = isChecked ? [...this.options] : [];

    // Emit manually once
    this.onChangeFn(this.selected);
    this.onTouchedFn();

    const valueToEmit = this.normalizeSelectionForEmit(this.selected, !!this.data?.isMultiSelect);

    if (this.data?.key) {
      this.globalFilterService.activeFilter = this.data.key;
      this.globalFilterService.updateFilterSelection(
        this.data.key,
        valueToEmit,
        this.data?.isQueryParam
      );
    }

    this.filterChanged.emit(valueToEmit);

    setTimeout(() => {
      this.suppressSelectionChange = false;
    }, 0);
  }

  onChange(event: any): void {
    if (this.suppressSelectionChange) return;
    this.onChangeFn(this.selected);
    this.onTouchedFn();

    const valueToEmit = this.normalizeSelectionForEmit(this.selected, !!this.data?.isMultiSelect);

    if (this.data?.key) {
      this.globalFilterService.activeFilter = this.data?.key;
      this.globalFilterService.updateFilterSelection(
        this.data?.key,
        valueToEmit,
        this.data?.isQueryParam
      );
    }

    this.filterChanged.emit(valueToEmit);
  }

  onItemClick(item: any): void {
    if (!this.data?.isMultiSelect) {
      if (this.selected === item) {
        // Unselect if same item clicked again
        this.selected = null;
        this.onChangeFn(this.selected);
        this.onTouchedFn();

        const valueToEmit = this.normalizeSelectionForEmit(this.selected, false);

        if (this.data?.key) {
          this.globalFilterService.activeFilter = this.data?.key;
          this.globalFilterService.updateFilterSelection(
            this.data.key,
            valueToEmit,
            this.data?.isQueryParam
          );
        }

        this.filterChanged.emit(valueToEmit);
      }
    }
  }

  removeSelected(item: any): void {
    if (!Array.isArray(this.selected)) {
      return;
    }
    this.selected = this.selected.filter((i: any) => i !== item);
    this.onChange(this.selected); // emit the change
  }

  onDropdownClose() {
    this.searchCtrl.setValue('', { emitEvent: true }); // clears input
  }

  writeValue(value: any): void {
    if (this.data?.isMultiSelect) {
      this.selected = this.normalizeSelectionForEmit(value, true);
      return;
    }

    if (Array.isArray(value)) {
      this.selected = value[0] ?? null;
      return;
    }

    this.selected = value ?? null;
  }

  private resetSelection(): void {
    this.suppressSelectionChange = true;
    this.selected = this.data?.isMultiSelect ? [] : null;
    this.searchCtrl.setValue('', { emitEvent: false });
    this.onChangeFn(this.selected);
    this.onTouchedFn();
    this.filterChanged.emit(this.selected);
    this.cdr.markForCheck();
    setTimeout(() => {
      this.suppressSelectionChange = false;
    }, 0);
  }

  private normalizeSelectionForEmit(value: any, isMultiSelect: boolean): any[] {
    const normalizeItem = (item: any): any => {
      if (typeof item === 'string') {
        return item.trim();
      }
      return item;
    };

    const isValidItem = (item: any): boolean => {
      if (item === null || item === undefined) {
        return false;
      }
      if (typeof item === 'string') {
        return item.length > 0;
      }
      return true;
    };

    if (isMultiSelect) {
      const values = Array.isArray(value) ? value.flat(Infinity) : (value !== null && value !== undefined ? [value] : []);
      return values
        .map((item) => normalizeItem(item))
        .filter((item) => isValidItem(item));
    }

    const singleValue = Array.isArray(value) ? value.flat(Infinity)[0] : value;
    const normalizedSingleValue = normalizeItem(singleValue);
    return isValidItem(normalizedSingleValue) ? [normalizedSingleValue] : [];
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  getItemLabel(item: any): string {
    // console.log('qwerty getItemLabel called with item:', item);
    if (item === null || item === undefined) return '';
    if (typeof item === 'string') { console.log('  qwerty item is string:', item); return item };
    if (item.bundle_name !== undefined) return item.bundle_name;
    if (item.bundle_id !== undefined) return item.bundle_id;
    if (item.product_name !== undefined) return item.product_name;
    if (item.name !== undefined) return item.name;
    if (item.value !== undefined) return item.value;
    try {
      return JSON.stringify(item);
    } catch {
      return String(item);
    }
  }

  setDisabledState(isDisabled: boolean): void { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
